function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/jsx-props-no-spreading */

import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
let ReactDOMClient;
try {
  ReactDOMClient = require('react-dom/client');
} catch (e) {
  // do nothing
}
export const withCompatMode = Component => {
  class CompatComponent extends PureComponent {
    constructor(props) {
      super(props);
      this.ref = /*#__PURE__*/React.createRef();
    }
    componentDidMount() {
      var _ReactDOMClient;
      const {
        innerRef
      } = this.props;
      const component = /*#__PURE__*/React.createElement(Component, _extends({}, this.props, {
        ref: innerRef
      }));
      if (typeof ((_ReactDOMClient = ReactDOMClient) === null || _ReactDOMClient === void 0 ? void 0 : _ReactDOMClient.createRoot) === 'function') {
        this.root = ReactDOMClient.createRoot(this.ref.current);
        this.root.render(component);
      } else {
        ReactDOM.render(component, this.ref.current);
      }
    }
    componentDidUpdate() {
      const {
        innerRef
      } = this.props;
      const component = /*#__PURE__*/React.createElement(Component, _extends({}, this.props, {
        ref: innerRef
      }));
      if (this.root) {
        this.root.render(component);
      } else {
        ReactDOM.render(component, this.ref.current);
      }
    }
    componentWillUnmount() {
      if (this.root) {
        this.root.unmount();
      } else {
        ReactDOM.render( /*#__PURE__*/React.createElement(React.Fragment, null), this.ref.current);
      }
    }
    render() {
      return /*#__PURE__*/React.createElement("div", {
        ref: this.ref
      });
    }
  }
  return {
    Component: /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      innerRef: ref
    })))),
    CompatComponent: /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(CompatComponent, _extends({}, props, {
      innerRef: ref
    }))),
    // @ts-expect-error will be set by chayns-toolkit via DefinePlugin
    requiredVersion: __REQUIRED_REACT_VERSION__,
    environment: process.env.NODE_ENV,
    buildEnv: process.env.BUILD_ENV || process.env.NODE_ENV,
    appVersion: process.env.VERSION
  };
};